export default __webpack_public_path__ + "static/media/child2.f30ef953.png";